// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___15UWE","title":"style__title___2n1-4","subtitle":"style__subtitle___3EiDE","topContainer":"style__topContainer___2lSeQ","bottomContainer":"style__bottomContainer___RgLtm","supportEmail":"style__supportEmail___3qjET","button":"style__button___2FVaP"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/screens/error/style.css
// module id = 1063
// module chunks = 0